import Swiper, { Navigation } from 'swiper'
import { breakpointUp } from '../utils/breakpoints'

function initBlockSlider() {

  if(!breakpointUp('md')) return false

  let swiper = new Swiper('.block-partners .swiper', {
    modules: [Navigation],
    slidesPerView: 6,
    spaceBetween: 30,
    navigation: {
      nextEl: '.block-partners .partners-slide-next',
      prevEl: '.block-partners .partners-slide-prev'
    },
  })

}

initBlockSlider()
